/**
 * @generated SignedSource<<8c99835fbb7a7a86f36fab01de2f9e84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRealtimeUpdater_spreadsheetGroupConnection$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraSpreadsheetGroupEdge";
  } | null | undefined> | null | undefined;
  readonly groupByField: string | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentType": "IssueRealtimeUpdater_spreadsheetGroupConnection";
};
export type IssueRealtimeUpdater_spreadsheetGroupConnection$key = {
  readonly " $data"?: IssueRealtimeUpdater_spreadsheetGroupConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRealtimeUpdater_spreadsheetGroupConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueRealtimeUpdater_spreadsheetGroupConnection",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "groupByField"
    },
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};

(node as any).hash = "f4c9f9679d436f8fef9fddc4aaf7fa66";

export default node;
